
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-tools",
      function () {
        return require("private-next-pages/health-tools/index.tsx");
      }
    ]);
  